export enum DistanceUnit {
    KM = "KM",
    MILE = "MILE",
    TIME = "TIME",
}


export enum ProgrammeType {
    FIVE_K = "5K",
    TEN_K = "10K",
    HALF_MARATHON = "HALF_MARATHON",
    MARATHON = "MARATHON",
    ULTRA_MARATHON = "ULTRA_MARATHON",
    NONE = "NONE",
    SOMETHING_ELSE = "SOMETHING_ELSE",
}

export enum RunningCommunity {
  RUN_CLUB = "RUN_CLUB",
  PARK_RUN = "PARK_RUN",
  NONE = "NONE"
}

export enum TrainingIntensityPreference {
    LOW = 0,
    MEDIUM = 1,
    HIGH = 2
}


export enum PlanStatus {
    INITIAL = "initial",
    READY = "ready",
    IN_PROGRESS = "in_progress",
    ERROR = "error",
}

export enum RunClubDifficulty {
    HARD = "HARD",
    MEDIUM = "MEDIUM",
    EASY = "EASY",
}

export enum ExperienceLevel {
    BEGINNER = "BEGINNER",
    NOVICE = "NOVICE",
    INTERMEDIATE = "INTERMEDIATE",
    ADVANCED = "ADVANCED",
}


